(function () {
  const OPEN_CLASS = 'is-open';

  function closePopover(popover) {
    if (!popover) return;
    popover.hidden = true;
    popover.classList.remove(OPEN_CLASS);
    const btn = document.querySelector(
      '[aria-controls="' + popover.id + '"]'
    );
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAllInSection(section) {
    section.querySelectorAll('.data-table-cell__popover.' + OPEN_CLASS).forEach(closePopover);
  }

  function openPopover(btn, popover) {
    const section = btn.closest('.data-table-section');
    if (section) closeAllInSection(section);

    popover.hidden = false;
    popover.classList.add(OPEN_CLASS);
    btn.setAttribute('aria-expanded', 'true');

    const closeBtn = popover.querySelector('.data-table-cell__popover-close');
    if (closeBtn) closeBtn.focus();
  }

  function initSection(section) {
    if (section.dataset.dataTableInit) return;
    section.dataset.dataTableInit = 'true';

    section.addEventListener('click', function (e) {
      const infoBtn = e.target.closest('.data-table-cell__info-btn');
      if (infoBtn) {
        e.preventDefault();
        e.stopPropagation();
        const popover = document.getElementById(infoBtn.getAttribute('aria-controls'));
        if (!popover) return;
        if (popover.classList.contains(OPEN_CLASS)) {
          closePopover(popover);
        } else {
          openPopover(infoBtn, popover);
        }
        return;
      }

      const closeBtn = e.target.closest('.data-table-cell__popover-close');
      if (closeBtn) {
        e.preventDefault();
        closePopover(closeBtn.closest('.data-table-cell__popover'));
        return;
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.data-table-cell__info-btn, .data-table-cell__popover')) return;
      closeAllInSection(section);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAllInSection(section);
    });
  }

  function init() {
    document.querySelectorAll('.data-table-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.data-table-section') || e.target;
    if (section && section.classList && section.classList.contains('data-table-section')) {
      initSection(section);
    } else if (e.target.querySelector) {
      e.target.querySelectorAll('.data-table-section').forEach(initSection);
    }
  });
})();
